import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { ServiceWorkerModule } from '@angular/service-worker';
import { REQ_RES_WORKER, PUB_SUB_WORKER, LRSI_WORKER_FACTORY } from '@oblac/shared/data-access';
import { MotionMasterConnectionConfig } from '@oblac/motion-master-client';

const reqResWorker = new Worker(new URL('./motion-master-req-res-client.worker', import.meta.url));
const pubSubWorker = new Worker(new URL('./motion-master-pub-sub-client.worker', import.meta.url));

/**
 * Creates and initializes a Web Worker dedicated to the Limited Range System Identification (LRSI) procedure.
 * The worker immediately attempts to connect to the Motion Master server upon creation.
 * The caller must listen for the worker's 'SUCCESS' or 'ERROR' messages to confirm connection status.
 *
 * @param config - The configuration required to establish the Motion Master connection inside the worker.
 * @returns A Worker instance ready to receive 'start' and 'disconnect' commands.
 */
function lrsiWorkerFactory(config: MotionMasterConnectionConfig) {
  const lrsiWorker = new Worker(new URL('./limited-range-system-identification.worker', import.meta.url));
  lrsiWorker.postMessage({ action: 'connect', payload: { config } });
  return lrsiWorker;
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(
      [
        {
          path: '',
          loadChildren: () =>
            import('@oblac/motion-master-console/feature-main').then(
              (module) => module.MotionMasterConsoleFeatureMainModule
            ),
        },
      ],
      { initialNavigation: 'enabledBlocking' }
    ),
    ToastrModule.forRoot({
      preventDuplicates: true,
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    { provide: REQ_RES_WORKER, useValue: reqResWorker },
    { provide: PUB_SUB_WORKER, useValue: pubSubWorker },
    { provide: PUB_SUB_WORKER, useValue: pubSubWorker },
    { provide: LRSI_WORKER_FACTORY, useValue: lrsiWorkerFactory },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
